"use client";

import { useState } from "react";
import Subtract from "@/public/icon/Subtract.svg";
import Image from "next/image";
import Link from "next/link";
import { Play } from "lucide-react";

export default function PicFrame({ 
  children, 
  btnText, 
  icon: Icon, 
  href = "", 
  hideOverlay = false,
  imageSrc,
  imageAlt = "image",
  videoSrc,
  sizes = "(max-width: 1024px) 100vw, 80vw",
  priority = false,
}) {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <section className="w-full h-[459px] lg:h-[545px] border-[16px] lg:border-32 border-black relative rounded-[64px] sm:rounded-72 overflow-hidden group">
      {videoSrc && showVideo ? (
        <video 
          src={videoSrc} 
          className="w-full h-full object-cover rounded-[64px] sm:rounded-72"
          controls 
          autoPlay 
          playsInline
        />
      ) : (
        imageSrc ? (
          <div 
            className={`relative w-full h-full ${videoSrc ? 'cursor-pointer' : ''}`} 
            onClick={() => videoSrc && setShowVideo(true)}
          >
            <Image 
              src={imageSrc} 
              alt={imageAlt} 
              fill
              className="rounded-[64px] sm:rounded-72 object-cover transition-transform duration-500 group-hover:scale-105" 
              priority={priority}
              fetchPriority={priority ? "high" : "auto"}
              quality={70}
              sizes={sizes}
            />
            {videoSrc && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-all rounded-[64px] sm:rounded-72">
                 <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center border border-white/30 transition-transform duration-300 group-hover:scale-110 shadow-lg">
                    <Play className="w-8 h-8 sm:w-10 sm:h-10 text-white fill-white translate-x-1" />
                 </div>
              </div>
            )}
          </div>
        ) : children
      )}

      {!hideOverlay && !showVideo && (
        <div className="w-fit flex justify-center translate-y-[8px] items-center h-[52px] px-8 sm:px-12 bg-black rounded-t-36 absolute bottom-0 left-1/2 -translate-x-1/2 z-10">
          <Link href={href} className="flex gap-x-2 text-sm shrink-0 text-white"> 
            {Icon && <Icon size={24} className={"translate-y-[-2px]"} />} 
            {btnText}
          </Link>
        
          <Image
            src={Subtract}
            alt=""
            aria-hidden="true"
            width={36}
            height={36}
            className="absolute bottom-0 left-0 -translate-x-[calc(100%-5.5px)] sm:-translate-x-[calc(100%-6.5px)] translate-y-[-7px]"
          />
          <Image
            src={Subtract}
            alt=""
            aria-hidden="true"
            width={36}
            height={36}
            className="absolute bottom-0 right-0 translate-x-[calc(100%-5.5px)] sm:translate-x-[calc(100%-6.5px)] translate-y-[-7px] rotate-90"
          />
        </div>
      )}
    </section>
  );
}
